import React, { useState, useEffect } from 'react';
import { Avatar, Button, Typography, DialogContent, DialogActions, Grid, IconButton } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useNavigate } from 'react-router-dom';
import { setEncryptedCookie, getDecryptedCookie, removeCookie } from '../../../utils';
import userApi from '../../../services/users';
import authApi from '../../../services/auth';
import { useDispatch, useSelector } from 'react-redux';
import { showLoader, hideLoader } from '../../../redux/loader/actions';
import { showSnackbar } from '../../../redux/snackbar/actions';

const BusinessSelection = ({ selectedOption, setSelectedOption }) => {
    const navigate = useNavigate();
    const [showSubmit, setShowSubmit] = useState(false);
    const dispatch = useDispatch();

    // const businessCount = useSelector((state) =>
    //     state.businessReducer.items.filter((item) => item.access_type !== 'none')
    // );

    const businessCount = JSON.parse(localStorage.getItem('businessCount')) || [];

    useEffect(() => {
        removeCookie('id');
        removeCookie('uuid');
    }, []);
    const [userId, setUserId] = useState();
    const handleSelect = async (businessId, businessUuid, businessName) => {
        if (businessUuid === undefined) {
            console.error('Invalid data: businessId or businessUuid is undefined');
            return;
        }
        removeCookie('uuid');
        removeCookie('abc');
        removeCookie('id');
        removeCookie('name');
        setEncryptedCookie('uuid', businessUuid);
        setEncryptedCookie('name', businessName);
        setSelectedOption(businessId);
        await editUserById(businessUuid);
        setUserId(businessUuid);
        setShowSubmit(true);
    };

    const businessUuid = getDecryptedCookie('uuid');

    const editUserById = async (userId) => {
        dispatch(showLoader());
        try {
            const response = await userApi.getUserId(userId);
            if (response?.data?.status) {
                setEncryptedCookie('abc', response.data.data[0].role.uuid);
                setEncryptedCookie('fdf', response.data.data[0].user.username, {
                    expires: 7
                });
                setEncryptedCookie('puser', response.data.data[0].user.parent_user_id, {
                    expires: 7
                });
                const id = response.data.data[0].role.uuid;
                setEncryptedCookie('id', id, { expires: 7 });
            } else {
                console.error('Error fetching user data');
            }
        } catch (error) {
            console.error('Error fetching user:', error);
        } finally {
            dispatch(hideLoader());
        }
    };

    const handleUserSubmit = () => {
        dispatch(showLoader());
        const onSuccess = (res) => {
            dispatch(hideLoader());
            navigate('/home');
            window.location.reload();
        };
        const onFailure = (err) => {
            dispatch(hideLoader());
        };
        authApi.userVerify(userId).then(onSuccess, onFailure);
    };
    return (
        <>
            <DialogContent sx={{ overflowX: 'hidden' }}>
                <Typography variant='h6' gutterBottom>
                    Select a Business
                </Typography>

                <Grid container spacing={2}>
                    {businessCount.map((business) => (
                        <Grid item xs={12} sm={6} key={business.id}>
                            <div
                                onClick={() => handleSelect(business.id, business.uuid, business.organization_name)}
                                style={{
                                    position: 'relative',
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: selectedOption === business.id ? '2px solid #1976d2' : 'none',
                                    borderRadius: '8px',
                                    textAlign: 'center'
                                }}
                            >
                                <Avatar sx={{ width: 56, height: 56, margin: 'auto' }}>
                                    {business.organization_name.charAt(0)}
                                </Avatar>
                                <Typography variant='body1'>{business.organization_name}</Typography>

                                {selectedOption === business.id && (
                                    <IconButton
                                        sx={{
                                            position: 'absolute',
                                            top: 0,
                                            right: 0,
                                            color: '#1976d2'
                                        }}
                                    >
                                        <CheckCircleIcon />
                                    </IconButton>
                                )}
                            </div>
                        </Grid>
                    ))}
                </Grid>
            </DialogContent>

            {showSubmit && (
                <DialogActions>
                    <Button
                        onClick={handleUserSubmit}
                        variant='contained'
                        sx={{
                            height: '100%',
                            background: 'linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)',
                            color: '#fff',
                            borderRadius: '8px',
                            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.2)',
                            textTransform: 'uppercase',
                            fontWeight: 'bold',
                            '&:hover': {
                                background: 'linear-gradient(45deg, #ff416c 30%, #ff4b2b 90%)',
                                boxShadow: '0px 6px 16px rgba(0, 0, 0, 0.3)'
                            }
                        }}
                    >
                        Continue
                    </Button>
                </DialogActions>
            )}
        </>
    );
};

export default BusinessSelection;
